import { useEffect, useState } from "react";
import { Button } from "src/@/components/ui/button";
import { Input } from "src/@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import { AlertInfo } from "src/@/components/shared/AlertInfo";
import { RowInput } from "src/components/forms/RowInput";
import { MultiSelect } from "src/@/components/ui/multi-select";
import getActionListaUsuariosByClienteId from "src/actions/usuarios/getActionListaUsuariosByClienteId";
import Scrollbar from "src/components/Scrollbar";
import { Switch } from "src/@/components/ui/switch";
import { hasServiceAi } from "src/helpers/auth.helper";
import { Textarea } from "src/@/components/ui/textarea";
import Iconify from "src/components/Iconify";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";
import { RadioGroup, RadioGroupItem } from "src/@/components/ui/radio-group";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "src/@/components/ui/tooltip";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose
} from 'src/@/components/ui/dialog';
import { Loader2, Sparkles } from 'lucide-react';
import v2_actionListaAgentesAi from 'src/actions/v2/ai/v2_actionListaAgentesAi';
import v3_actionGeneratePrompts from "src/actions/v3/ai/v3_actionGeneratePrompts";
import { Divider } from "@mui/material";
import v2_actionListaTagsChats from "src/actions/v2/chats/v2_actionListaTagsChats";
import actionListaCanaisPorCliente from "src/actions/clientes/actionListaCanaisPorCliente";

const ChatKeywordFilter = ({
  user,
  cliente,
  actionPhase,
  actionState,
  changeActionState
}) => {
  const [filterType, setFilterType] = useState("contains"); // "equal" or "contains"
  const [keywords, setKeywords] = useState("");
  const [keywordList, setKeywordList] = useState([]);
  const [users, setUsers] = useState([]);
  const [aiDetectContext, setAiDetectContext] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isGeneratingPrompt, setIsGeneratingPrompt] = useState(false);
  const [promptDescription, setPromptDescription] = useState('');
  const [generatedPrompt, setGeneratedPrompt] = useState('');
  const [availableAgents, setAvailableAgents] = useState([]);

  const [tags, setTags] = useState([]);
  const [canais, setCanais] = useState([]);

  async function buscarListaTags() {
    try {
      const querys = `?cliente_id=${cliente._id}`;
      const response = await v2_actionListaTagsChats(querys);
      setTags(response.data.data);
    } catch (error) {
      console.error("Erro ao buscar lista de tags:", error);
    }
  }

  useEffect(() => {
    buscarListaTags();
  }, []);

  const listFormat = tags.map((tag) => ({
    value: tag._id,
    label: tag.nome,
  }));

  async function buscarListaCanais() {
    try {
      const response = await actionListaCanaisPorCliente(cliente._id);
      setCanais(response.data.data || []);
    } catch (error) {
      console.error("Erro ao buscar lista de canais:", error);
    }
  }

  let canaisFormatted = canais?.map((canal) => {
    return {
      value: canal.cliente_id || canal.clienteId,
      label: canal.nome
    }
  });



  const STATUS = [
    {
      value: "Atendendo",
      label: "Atendendo"
    },
    {
      value: "Avaliando",
      label: "Avaliando"
    },
    {
      value: "Pendente",
      label: "Em Fila"
    },
    {
      value: "Geral",
      label: "No bot"
    },
    {
      value: "Finalizado",
      label: "Finalizado"
    }
  ]


  let usersFormatted = users?.map((user) => {
    return {
      value: user._id,
      label: user.nomeFantasia
    }
  });

  async function getUsers() {
    try {
      const response = await getActionListaUsuariosByClienteId(user?.clienteId);
      setUsers(response.data.usuarios);

    } catch (error) {
      console.log(error);
    }
  }

  async function getAvailableAgents() {
    try {
      const response = await v2_actionListaAgentesAi(user?.clienteId);
      if (response.data.data && response.data.data.length > 0) {
        setAvailableAgents(response.data.data);
      }
    } catch (error) {
      console.log('Erro ao buscar agentes de IA:', error);
    }
  }


  const handleAddKeyword = () => {
    if (keywords.trim()) {
      let event = {
        name: "chatKeywords",
        value: [...actionState?.chatKeywords, keywords.trim()]
      }
      changeActionState(event);
      setKeywordList([...keywordList, keywords.trim()]);
      setKeywords("");
    }
  };

  const handleRemoveKeyword = (keywordToRemove) => {
    let event = {
      name: "chatKeywords",
      value: actionState?.chatKeywords.filter((keyword) => keyword !== keywordToRemove)
    }
    changeActionState(event);
  };

  const generatePromptWithAI = async () => {
    if (!promptDescription.trim()) return;

    setIsGeneratingPrompt(true);
    try {

      const response = await v3_actionGeneratePrompts(user?.clienteId, {
        type: "automation_detect_context",
        text: promptDescription
      });
      const generatedText = response.data.data;

      setGeneratedPrompt(generatedText);
    } catch (error) {
      console.error('Erro ao gerar prompt:', error);
      if (error.message === 'Nenhum agente de IA disponível') {
        setGeneratedPrompt('Nenhum agente de IA configurado. Configure um agente de IA primeiro.');
      } else {
        setGeneratedPrompt('Erro ao gerar prompt. Verifique se há agentes de IA configurados e tente novamente.');
      }
    } finally {
      setIsGeneratingPrompt(false);
    }
  };

  const applyGeneratedPrompt = () => {
    if (generatedPrompt) {
      changeActionState({ name: "aiDetectContext", value: generatedPrompt });
      setIsModalOpen(false);
      setPromptDescription('');
      setGeneratedPrompt('');
    }
  };

  useEffect(() => {
    getUsers();
    getAvailableAgents();
    buscarListaCanais();
  }, []);

  useEffect(() => {


  }, [actionState]);

  return (
    <Card className="w-full">
      <CardHeader>
        <LabelFromAction>
          {actionPhase.name}
        </LabelFromAction>
      </CardHeader>
      <CardContent>
        <div className="space-y-4 flex flex-col gap-2">
          {/* Input for Keywords */}

          {/* <div className="flex items-center gap-2 mt-4">
            <Switch
              //defaultValue={actionState?.detectTypeMsg}
              checked={actionState?.detectTypeMsg}
              onCheckedChange={(checked) =>  changeActionState({ name: "detectTypeMsg", value: checked })}
            />
            <label className="text-sm font-medium">Tipo de mensagem</label>
          </div> */}

          <div className="flex items-center gap-2 mt-4">
            <Switch
              //defaultValue={actionState?.aiDetect}
              checked={actionState?.aiDetect}
              onCheckedChange={(checked) => changeActionState({ name: "aiDetect", value: checked })}
            />
            <label className="text-sm font-medium">Detecção por IA</label>
          </div>


          {
            actionState?.detectTypeMsg && (
              <div className="space-y-4 mb-8">
                <div className="grid grid-cols-2 gap-4">
                  <div className="col-span-2">
                    <RowInput
                      label="Tipos de mensagem"
                      input={
                        <MultiSelect
                          options={[
                            { value: "image", label: "Imagem" },
                            { value: "document", label: "Documento" },
                            { value: "video", label: "Vídeo" },
                            { value: "audio", label: "Áudio" },
                            { value: "ppt", label: "Mensagem de Voz" }
                          ]}
                          onValueChange={(e) => {
                            changeActionState({ name: "detectTypeMsgTypes", value: e });
                          }}
                          defaultValue={actionState?.messageTypes || []}
                          placeholder="Selecionar tipos de mensagem"
                          variant="inverted"
                          animation={2}
                          maxCount={5}
                        />
                      }
                    />
                  </div>
                </div>

                {actionState?.messageTypes && actionState.messageTypes.length > 0 && (
                  <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                    <p className="text-sm text-blue-800 mb-2">
                      <strong>Tipos selecionados:</strong>
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {actionState.messageTypes.map((type, index) => (
                        <span
                          key={index}
                          className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full flex items-center gap-1"
                        >
                          {type === "image" && <Iconify icon="material-symbols:image-outline" className="w-3 h-3" />}
                          {type === "document" && <Iconify icon="solar:file-linear" className="w-3 h-3" />}
                          {type === "video" && <Iconify icon="mdi:video" className="w-3 h-3" />}
                          {type === "audio" && <Iconify icon="mdi:microphone" className="w-3 h-3" />}
                          {type === "voice" && <Iconify icon="mingcute:voice-fill" className="w-3 h-3" />}
                          {
                            type === "image" ? "Imagem" :
                              type === "document" ? "Documento" :
                                type === "video" ? "Vídeo" :
                                  type === "audio" ? "Áudio" :
                                    type === "voice" ? "Mensagem de Voz" : type
                          }
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )
          }


          {actionState?.aiDetect && !actionState?.detectTypeMsg ? (
            <div className="space-y-4 mb-8">

              {/* <div className="flex items-center gap-2">
                <Switch
                  defaultValue={actionState?.aiSilent}
                  checked={actionState?.aiSilent}
                  onCheckedChange={(checked) => changeActionState({ name: "aiSilent", value: checked })}
                />
                <label className="text-sm font-medium">Silenciar IA</label>
              </div> */}

              <RowInput
                isRequired={true}
                label="Inserir contexto"
                input={<div className="flex items-center space-x-2">
                  <div className="flex-1 relative">
                    <Textarea
                      placeholder="Digite o contexto para a detecção por IA"
                      value={actionState?.aiDetectContext}
                      onChange={(e) => changeActionState({ name: "aiDetectContext", value: e.target.value })}
                      className="w-full pr-12"
                      rows={5}
                    />
                    <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
                      <DialogTrigger asChild>
                        <Button
                          type="button"
                          variant="outline"
                          size="sm"
                          className="absolute top-2 right-2 h-8 w-8 p-0"
                          title={availableAgents.length > 0 ? "Gerar contexto com IA" : "Configure um agente de IA primeiro"}
                        //disabled={availableAgents.length === 0}
                        >
                          <Sparkles className="h-4 w-4" />
                        </Button>
                      </DialogTrigger>
                      <DialogContent className="max-w-2xl">
                        <DialogHeader>
                          <DialogTitle className="flex items-center gap-2">
                            <Sparkles className="h-5 w-5" />
                            Gerar Contexto com IA
                          </DialogTitle>
                        </DialogHeader>

                        <div className="space-y-4">
                          <>
                            <div>
                              <label className="text-sm font-medium mb-2 block">
                                Descreva o que você quer detectar
                              </label>
                              <Textarea
                                placeholder="Ex: Clientes insatisfeitos, pedidos de reembolso, dúvidas sobre produtos, etc."
                                value={promptDescription}
                                onChange={(e) => setPromptDescription(e.target.value)}
                                className="w-full"
                                rows={4}
                              />
                              <p className="text-xs text-muted-foreground mt-1">
                                Descreva de forma clara o tipo de situação ou comportamento que você quer que a IA detecte.
                              </p>
                            </div>
                          </>

                          <Button
                            onClick={generatePromptWithAI}
                            disabled={!promptDescription.trim() || isGeneratingPrompt}
                            className="w-full"
                          >
                            {isGeneratingPrompt ? (
                              <>
                                <Loader2 className="h-4 w-4 animate-spin mr-2" />
                                Gerando contexto...
                              </>
                            ) : (
                              <>
                                <Sparkles className="h-4 w-4 mr-2" />
                                Gerar Contexto
                              </>
                            )}
                          </Button>

                          {generatedPrompt && (
                            <div className="space-y-3">
                              <div>
                                <label className="text-sm font-medium mb-2 block">
                                  Contexto Gerado
                                </label>
                                <div className="p-3 bg-slate-50 border rounded-md">
                                  <p className="text-sm whitespace-pre-wrap">{generatedPrompt}</p>
                                </div>
                              </div>

                              <div className="flex gap-2">
                                <Button
                                  onClick={applyGeneratedPrompt}
                                  className="flex-1"
                                >
                                  Aplicar Contexto
                                </Button>
                                <Button
                                  variant="outline"
                                  onClick={() => {
                                    setGeneratedPrompt('');
                                    setPromptDescription('');
                                  }}
                                >
                                  Gerar Novamente
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>
                      </DialogContent>
                    </Dialog>
                  </div>
                </div>}
              />

              <RowInput
                label="Quantidade de mensagens do agente a buscar"
                input={<div className="flex items-center space-x-2">
                  <Input
                    type="number"
                    min={0}
                    placeholder="Ex: 10"
                    value={actionState?.limitMsgAgent === null ? '0' : actionState?.limitMsgAgent || ''}
                    onChange={e => {
                      const value = Number(e.target.value);
                      changeActionState({
                        name: "limitMsgAgent",
                        value: value === 0 ? null : value
                      });
                    }}
                    className="w-32"
                  />
                </div>}
              />

              <RowInput
                label="Quantidade de mensagens do cliente a buscar"
                input={<div className="flex items-center space-x-2">
                  <Input
                    type="number"
                    min={0}
                    placeholder="Ex: 10"
                    value={actionState?.limitMsgClient === null ? '0' : actionState?.limitMsgClient || ''}
                    onChange={e => {
                      const value = Number(e.target.value);
                      changeActionState({
                        name: "limitMsgClient",
                        value: value === 0 ? null : value
                      });
                    }}
                    className="w-32"
                  />
                </div>}
              />

              <RowInput
                isRequired={true}
                label="Nível de inteligência da análise"
                input={
                  <div className="flex items-center gap-2">
                    <RadioGroup
                      value={actionState?.aiIntelligenceLevel || "basico"}
                      onValueChange={(value) => changeActionState({ name: "aiIntelligenceLevel", value })}
                      className="flex flex-row items-center gap-2"
                    >
                      <div className="flex items-center space-x-2">
                        <RadioGroupItem value="basico" id="basico" />
                        <label htmlFor="basico" className="text-sm font-medium">gpt 1</label>
                      </div>
                      <div className="flex items-center space-x-2">
                        <RadioGroupItem value="avancado" id="avancado" />
                        <label htmlFor="avancado" className="text-sm font-medium">gpt 2</label>
                      </div>

                    </RadioGroup>
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <span tabIndex={0} className="flex items-center">
                            <Iconify icon="mdi:information-outline" width={18} className="text-slate-500 cursor-pointer" />
                          </span>
                        </TooltipTrigger>
                        <TooltipContent side="top" align="center" className="w-[270px]">
                          <div className="space-y-2">
                            <p><strong>gpt1:</strong> Análise simples de palavras-chave e frases diretas.</p>
                            <p><strong>gpt2:</strong> Análise contextual mais profunda, considerando nuances e intenções.</p>
                          </div>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </div>
                }
              />

              <RowInput
                isRequired={true}
                label="Origem da análise"
                input={
                  <div className="flex items-center gap-2">
                    <RadioGroup
                      value={actionState?.aiAnalysisSource || "cliente"}
                      onValueChange={(value) => changeActionState({ name: "aiAnalysisSource", value })}
                      className="flex flex-row items-center gap-2"
                    >
                      <div className="flex items-center space-x-2">
                        <RadioGroupItem value="cliente" id="cliente" />
                        <label htmlFor="cliente" className="text-sm font-medium">Cliente</label>
                      </div>
                      <div className="flex items-center space-x-2">
                        <RadioGroupItem value="agente" id="agente" />
                        <label htmlFor="agente" className="text-sm font-medium">Agente</label>
                      </div>
                    </RadioGroup>
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <span tabIndex={0} className="flex items-center">
                            <Iconify icon="mdi:information-outline" width={18} className="text-slate-500 cursor-pointer" />
                          </span>
                        </TooltipTrigger>
                        <TooltipContent side="top" align="center" className="w-[270px]">
                          <div className="space-y-2">
                            <p><strong>Cliente:</strong> A análise será feita a partir das mensagens enviadas pelo cliente.</p>
                            <p><strong>Agente:</strong> A análise será feita a partir das mensagens enviadas pelo agente.</p>
                          </div>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </div>
                }
              />

            </div>
          ) : (

            !actionState?.detectTypeMsg && (
              <div className="space-y-4">
                <RowInput
                  isRequired={true}
                  label="Adicionar gatilhos"
                  input={<div className="flex items-center space-x-2">
                    <Input
                      placeholder="Digite uma palavra, frase ou contexto"
                      value={keywords}
                      onChange={(e) => setKeywords(e.target.value)}
                      className="w-full"
                      rows={3}
                      onKeyPress={(e) => e.key === "Enter" && handleAddKeyword()}
                    />
                    <Button className="bg-slate-800" onClick={handleAddKeyword}>
                      <Iconify icon="mdi:plus" />
                    </Button>
                  </div>}
                />
                {/* List of Added Keywords */}
                <div className="space-y-2 mb-4">
                  <h4 className="text-xs font-medium">Gatilhos adicionados:</h4>
                  <Scrollbar className="max-h-48">
                    <ul className="list-disc space-y-2">
                      {actionState?.chatKeywords.map((keyword, index) => (
                        <li key={index} className="flex items-center justify-between">
                          <div className="px-2 bg-slate-100 border-slate-200 border rounded text-sm">{keyword}</div>

                          <Button
                            variant="secondary"
                            onClick={() => handleRemoveKeyword(keyword.toString())}
                            className="text-red-500 bg-red-100 h-6"
                          >
                            Remover
                          </Button>
                        </li>
                      ))}
                    </ul>
                  </Scrollbar>
                </div>

              </div>
            )


          )}


          <div>
            <RowInput
              isRequired={true}
              label="Canal"
              info={"Canais que estão atrelados ao chat"}
              input={
                <MultiSelect
                  options={canaisFormatted}
                  onValueChange={(e) =>
                    changeActionState({ name: "chatChannels", value: e })
                  }
                  defaultValue={actionState.chatChannels}
                  placeholder="Selecionar canais"
                  variant="inverted"
                  animation={2}
                  maxCount={3}
                />
              }
            />
          </div>

          <div>
            <RowInput
              isRequired={true}
              label="Status do Chat"
              input={<MultiSelect
                options={STATUS.map((status) => ({
                  value: status.value,
                  label: status.label,
                }))
                }
                onValueChange={(e) => changeActionState({ name: "chatStatus", value: e })}
                defaultValue={actionState?.chatStatus}
                placeholder="Selecionar status"
                variant="inverted"
                animation={2}
                maxCount={3}
              />
              }
            />
          </div>


          <div className="text-sm font-semibold bg-slate-100 p-2 rounded-md mt-12">
            Filtros
          </div>


          <RowInput
            label="Usuários do chat"
            input={
              <MultiSelect
                options={usersFormatted}
                onValueChange={(e) =>
                  changeActionState({ name: "chatUsersAssign", value: e })
                }
                defaultValue={actionState.chatUsersAssign}
                placeholder="Selecionar usuarios"
                variant="inverted"
                animation={2}
                maxCount={3}
              />
            }
          />

          <RowInput
            label="Tags chat"
            input={
              <MultiSelect
                options={listFormat}
                onValueChange={(e) =>
                  changeActionState({ name: "chatTags", value: e })
                }
                defaultValue={actionState.chatTags}
                placeholder="Selecionar Tags"
                variant="inverted"
                animation={2}
                maxCount={3}
              />
            }
          />



          <AutomationOnlyExecute
            actionState={actionState}
            changeActionState={changeActionState}
          />




        </div>
      </CardContent>
    </Card>
  );
};

export default ChatKeywordFilter;
